import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[noNegativeInput]',
})
export class NoNegativeInputDirective {
  /** Number of decimal places allowed. 0 = integer only */
  @Input() decimalPlaces: number = 0;

  constructor(private ngControl: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
    if (allowedKeys.includes(event.key)) return;

    if (/^[0-9]$/.test(event.key)) return;

    // Allow decimal if allowed and not already exceeded
    if (this.decimalPlaces > 0 && event.key === '.' && !input.value.includes('.')) return;

    if (['e', 'E', '+', '-'].includes(event.key) || (event.key === '.' && this.decimalPlaces === 0)) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let raw = input.value;

    if (this.decimalPlaces > 0) {
      // Keep only digits and dot
      raw = raw.replace(/[^0-9.]/g, '');
      const parts = raw.split('.');

      // Only one dot
      if (parts.length > 2) {
        raw = parts[0] + '.' + parts[1];
      }

      // Limit decimal places
      if (parts[1]?.length > this.decimalPlaces) {
        raw = parts[0] + '.' + parts[1].substring(0, this.decimalPlaces);
      }
    } else {
      // Integer only
      raw = raw.replace(/\D/g, '');
    }

    // Update FormControl (keep as string to allow typing)
    this.ngControl.control?.setValue(raw, { emitEvent: false });
  }
}
